<template>
  <div class="layout-box">
    <div class="layout-box__container">
      <div class="layout-box__header">
        <SecurityLogoVerticalSvg />
      </div>

      <div class="layout-box__body">
        <ButtonGoogleSignIn @click.native="signIn" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'LoginView',

  computed: {
    ...mapState('auth', [
      'isAuthInit',
      'isSignIn'
    ])
  },

  methods: {
    ...mapMutations('auth', ['SET_IS_SIGN_IN']),

    async signIn () {
      await this.$gAuth.signIn()
        .then((user) => {
          this.SET_IS_SIGN_IN(this.$gAuth.isAuthorized)

          if (this.isSignIn) {
            this.$parent.userProfileRefresh()
            this.$router.push({ name: 'access-management' })
          }
        })
        .catch((error) => {
          throw error
        })
    }
  }
}
</script>
